var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('Menu'),_c('SubMenu'),(_vm.selectedSurveyId && _vm.canShowThePage)?_c('CardController'):_vm._e(),(!_vm.selectedSurveyId && _vm.canShowThePage)?_c('NoDataToShow',{attrs:{"title":"dashboard.no_responses"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }